import React from 'react'
import MuiTable from '../../../Forms/SharedComponents/containers/MuiTable'
import { TABLA_MONITOR_BODEGA_DESTINO } from '../../../../config/tables'

function TablaMonitorPorBodegaDestino () {
  return (
    <MuiTable id={TABLA_MONITOR_BODEGA_DESTINO} />
  )
}

export default TablaMonitorPorBodegaDestino
